export const SELECTED_CLUSTER_PARAM = 'cluster';
